import React, { useState ,useEffect} from 'react';
import './contactus.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    message: '',
  });
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await fetch('https://swarna-herbal-backend.onrender.com/api/contact/add-user-message', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess(true);
        setFormData({
          name: '',
          phone: '',
          message: '',
        });
      } else {
        setError(result.error || 'Something went wrong');
      }
    } catch (error) {
      setError('Failed to send message. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("userDetails"));
    if (user) {
      setFormData({...formData,name:user.name,phone:user.phone});
    }
  }, []);
  return (
    <div className="contact-us">
      <div className="contact-container">
        <h2 style={{ fontSize: "1.7rem" }}>Feedback / enquiry</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              type="number"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder='write your queries....'
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Sending...' : 'Send Message'}
          </button>
          {error && <p className="error">{error}</p>}
          {success && <p className="success">Message sent successfully!</p>}
        </form>

        {/* Contact Info */}
        <div className="contact-info">
          <h3>Need immediate assistance?</h3>
          <p>You can also reach out to us via the following methods:</p>
          <ul>
            <li><strong>Phone:</strong> <a href="tel:+917828215766">+917828215766</a></li>
            <li><strong>Email:</strong> <a href="mailto:sonadevibhadoriya@gmail.com">sonadevibhadoriya@gmail.com</a></li>
            <li><strong>Instagram:</strong><a href="https://www.instagram.com/swarnaherbalproducts?igsh=MTlqcHpldDI3dmFnYQ==" target="_blank" rel="noopener noreferrer">swarnaherbalproducts</a></li>
            <li><strong>Facebook:</strong> <a href="https://www.facebook.com/share/15fiviMQuo/" target="_blank" rel="noopener noreferrer">swarnaherbalproducts</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
